export default __webpack_public_path__ + "static/media/icn-arrow-close-search.e6991eb9.svg";